import { TrackEventName } from '@wix/wixstores-client-core';
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService(_a) {
        var siteStore = _a.siteStore;
        this.siteStore = siteStore;
    }
    AnalyticsService.prototype.trackRemoveLineItem = function (_a) {
        var _b, _c, _d, _e;
        var lineItemId = _a.lineItemId, updatedCart = _a.updatedCart, previousCart = _a.previousCart;
        var lineItem = previousCart.lineItems.find(function (_a) {
            var _id = _a._id;
            return _id === lineItemId;
        });
        this.siteStore.trackEvent(TrackEventName.REMOVE_FROM_CART, {
            id: (_b = lineItem.catalogReference) === null || _b === void 0 ? void 0 : _b.catalogItemId,
            name: (_c = lineItem.productName) === null || _c === void 0 ? void 0 : _c.original,
            price: (_d = lineItem.price) === null || _d === void 0 ? void 0 : _d.amount,
            quantity: lineItem.quantity,
            sku: (_e = lineItem.physicalProperties) === null || _e === void 0 ? void 0 : _e.sku,
            currency: updatedCart.currency,
        });
    };
    return AnalyticsService;
}());
export { AnalyticsService };
//# sourceMappingURL=AnalyticsService.js.map